import React from 'react';

import type { FlagIconProps } from './icon-types';

export const FlagItaly: React.FC<FlagIconProps> = ({ size, isCircle = true }) => (
  <svg
    viewBox="0 0 126 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: size, height: size }}
  >
    <defs>
      {isCircle && (
        // eslint-disable-next-line react/no-unknown-property
        <mask id="circle" mask-type="luminance">
          <circle cx="63" cy="63" r="63" fill="white" />
        </mask>
      )}
    </defs>
    <g mask={isCircle ? 'url(#circle)' : undefined}>
      <path d="M42 0H0V126H42Z" fill="#099345" />
      <path d="M84 0H42V126H84Z" fill="white" />
      <path d="M126 0H84V126H126Z" fill="#EC1C24" />
    </g>
  </svg>
);
